import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/avatar.png';
import Avatar from 'components/common/Avatar';
import { useAuth } from 'hooks/useAuth';
import AppContext from 'context/Context';

const ProfileDropdown = () => {
  const { setConfig } = useContext(AppContext);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const userLogout = () => {
    setConfig('navbarCollapsed', true);
    setConfig('showBurgerMenu', false);
    logout();
  };
  return (
    <Dropdown navbar={true} as="li" className="flex align-items-center">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 nav-link d-flex align-items-center justify-content-center"
      >
        <Avatar src={team3} className="m-auto" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item onClick={userLogout} as={Link} to="">
            <span>Logout</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
